import { render, staticRenderFns } from "./editClasses.vue?vue&type=template&id=6ccaf83a&scoped=true&"
import script from "./editClasses.vue?vue&type=script&lang=js&"
export * from "./editClasses.vue?vue&type=script&lang=js&"
import style0 from "./editClasses.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editClasses.vue?vue&type=style&index=1&id=6ccaf83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccaf83a",
  null
  
)

export default component.exports